import Swiper, { Pagination, Navigation } from "swiper";
/**
 * Wrapper function to safely use $
 */
function wppsWrapper($) {
  var wpps = {
    /**
     * Main entry point
     */
    init: function () {
      wpps.prefix = "wpps_";
      wpps.modal = $("#investor-channel-modal").detach();

      $("body").append(wpps.modal);

      wpps.registerEventHandlers();
    },

    cleanUpModal: function () {
      wpps.modal.fadeOut();
      wpps.modal.find(".investor-channel-modal-inner").empty();
    },

    loadCarousel: function (value, $mainContainer) {
      const $loadingImage = $mainContainer
        .find(".investor-channel-loading-image img")
        .show();

      $.get($mainContainer.data("ajax-url") + "/" + value, function (data) {
        if (data && data.hasOwnProperty("result")) {
          if (
            data.result.hasOwnProperty("videos") &&
            data.result.videos.length > 0
          ) {
            $loadingImage.hide();

            const $carouselContainer = $mainContainer.find(".swiper-wrapper");
            const videos = data.result.videos;

            $mainContainer
              .find("p.investor-channel-watchlist-name")
              .text(data.result.name);

            $carouselContainer.html("");

            for (var i = 0; i < videos.length; i++) {
              let date = new Date(videos[i].publishedAt);
              let $div = $("<div>")
                .addClass("investor-channel-swiper-item")
                .addClass("swiper-slide");

              let $anchor = $("<a>")
                .attr("href", videos[i].video)
                .addClass("glightbox")
                .attr("target", "_blank")
                .attr("rel", "noopener nofollow noreferrer")
                .attr("title", data.result.name)
                .append(
                  $(
                    "div.investor-channel-swiper-container > div.investor-channel-swiper-item-overlay"
                  ).clone()
                )
                .append(
                  $("<img>")
                    .attr("width", "100%")
                    .attr("height", "100%")
                    .attr("src", videos[i].thumbnailImage)
                    .attr("alt", "Watchlist")
                )
                .on("click", function (e) {
                  wpps.modal.fadeIn();

                  let $modalBody = wpps.modal.find(
                    ".investor-channel-modal-inner"
                  );

                  $modalBody.append(
                    $("<iframe>")
                      .attr("width", "100%")
                      .attr("frameborder", "0")
                      .attr(
                        "src",
                        "https://www.youtube.com/embed/" +
                          $(this).attr("href") +
                          "?autoplay=1&playsinline=1"
                      )
                  );

                  e.preventDefault();
                });

              $div
                .append($anchor)
                .append($("<p>").html(date.toLocaleDateString()));

              $carouselContainer.append($div);
            }

            // configure Swiper to use modules
            Swiper.use([Pagination, Navigation]);

            new Swiper(".investor-channel-swiper-container", {
              spaceBetween: 20,
              mousewheel: true,
              keyboard: true,
              cssMode: true,
              slidesPerView: "auto",
              pagination: {
                el: ".investor-channel-swiper-pagination",
                dynamicBullets: true,
                clickable: true,
              },
              navigation: {
                nextEl: ".investor-channel-swiper-button-next",
                prevEl: ".investor-channel-swiper-button-prev",
              },
            });
          }
        }
      });
    },

    /**
     * Registers event handlers
     */
    registerEventHandlers: function () {
      const $mainContainers = $(".investor-channel-watchlist");
      const $select = $mainContainers.find("select");

      $select.on("change", function (e) {
        wpps.loadCarousel(this.value, $("#" + $(this).data("target")));
      });

      //loop over all containers just in case we have multiple shortcodes
      $.each($mainContainers, function (key, value) {
        let $value = $(value);

        if (typeof $value.data("initial-id") !== "undefined") {
          wpps.loadCarousel($value.data("initial-id"), $value);
        }
      });

      // When the user clicks anywhere outside of the modal, close it
      window.onclick = function (event) {
        if (event.target == document.getElementById("investor-channel-modal")) {
          wpps.cleanUpModal();
        }
      };

      // When the user clicks on <span> (x), close the modal
      wpps.modal.find(".investor-channel-close").on("click", function (e) {
        console.log("close");
        wpps.cleanUpModal();
        e.preventDefault();
      });
    },

    /**
     * Example event handler
     *
     * @param object event
     */
    // exampleHandler: function (event) {
    //   alert($(this).attr("href"));

    //   event.preventDefault();
    // },
  }; // end wpps

  $(document).ready(wpps.init);
} // end wppsWrapper()

wppsWrapper(jQuery);
